// Components
import { Typography } from '@archieai/ui';

// Utils
import { cn } from '../../utils/cn';

// Types
type ArticleSidebarProps = {
  /** Author name */
  author: string;
  /** Categories array */
  categories: string[];
  /** Article type (e.g., "Article", "Playbook", "News") */
  type: string;
  /** Additional className for custom styling */
  className?: string;
};

/**
 * ArticleSidebar - Sidebar metadata component for article detail page
 * Displays author, categories, and article type
 */
export const ArticleSidebar = ({
  author,
  categories,
  type,
  className,
}: ArticleSidebarProps) => {
  return (
    <aside
      className={cn(
        'flex flex-col gap-[var(--spacing-24)] w-full',
        'max-lg:flex-row max-lg:flex-wrap max-lg:gap-[var(--spacing-32)]',
        className
      )}
    >
      {/* Author Section */}
      <div className="flex flex-col gap-[var(--spacing-8)]">
        <Typography
          variant="column-header"
          className="text-blue-1000 uppercase tracking-wide"
        >
          Author
        </Typography>
        <Typography as="p" variant="h4" className="text-blue-800">
          {author}
        </Typography>
      </div>

      {/* Categories Section */}
      <div className="flex flex-col gap-[var(--spacing-8)]">
        <Typography
          variant="column-header"
          className="text-blue-1000 uppercase tracking-wide"
        >
          Category
        </Typography>
        <div className="flex flex-col gap-[var(--spacing-8)]">
          {categories.map((category, index) => (
            <Typography
              key={index}
              as="p"
              variant="small"
              className="text-blue-800"
            >
              {category}
            </Typography>
          ))}
        </div>
      </div>

      {/* Type Section */}
      <div className="flex flex-col gap-[var(--spacing-8)]">
        <Typography
          variant="column-header"
          className="text-blue-1000 uppercase tracking-wide"
        >
          Type
        </Typography>
        <Typography as="p" variant="small" className="text-blue-800">
          {type}
        </Typography>
      </div>
    </aside>
  );
};

